export default __webpack_public_path__ + "static/media/alan.508692a6.webp";